import 'styles/common/quantity-input.scss';
import Minus from '!svg-react-loader?!images/icons/icon-minus.svg';
import Plus from '!svg-react-loader?!images/icons/icon-plus.svg';

import React from 'react';
import classNames from 'classnames';
import propTypes from 'propTypes';

export const INCREMENT_CLASS_NAME = 'QuantityInput__increment';
export const DECREMENT_CLASS_NAME = 'QuantityInput__decrement';

export default class QuantityInput extends React.Component {
  static propTypes = {
    color: propTypes.string,
    defaultQuantity: propTypes.number,
    disableDecrement: propTypes.bool,
    disableIncrement: propTypes.bool,
    maximum: propTypes.number,
    minimum: propTypes.number,
    onChange: propTypes.func.isRequired,
    readOnly: propTypes.bool,
    value: propTypes.number.isRequired,
  };

  static defaultProps = {
    color: null,
    disableDecrement: false,
    disableIncrement: false,
    maximum: Infinity,
    minimum: 0,
    readOnly: false,
  };

  componentWillMount() {
    this.setDefaultValue();
  }

  componentDidUpdate() {
    this.setDefaultValue();
  }

  setDefaultValue = () => {
    const { defaultQuantity, value } = this.props;
    value < defaultQuantity && this.incrementValue();
  };

  isDisabled = disableProp => this.props.readOnly || disableProp;

  canIncrement = () => {
    const { disableIncrement, value, maximum } = this.props;
    return !this.isDisabled(disableIncrement) && value < maximum;
  };

  canDecrement = () => {
    const { disableDecrement, value, minimum } = this.props;
    return !this.isDisabled(disableDecrement) && value > minimum;
  };

  decrementValue = () =>
    this.canDecrement() && this.props.onChange(this.props.value - 1);

  incrementValue = () =>
    this.canIncrement() && this.props.onChange(this.props.value + 1);

  // this appears to be the best option for preventing
  // the iOS "double tap to zoom" feature on a particular DOM
  // element
  // otherwise, it's very easy to trigger an unwanted zoom
  // by increasing or decreasing a value by >= 2
  handleTouchEnd = event => {
    event.preventDefault();
    event.target.click();
  };

  render() {
    const {
      color,
      disableDecrement,
      disableIncrement,
      onChange,
      readOnly,
      value,
    } = this.props;
    const className = classNames(this.props.className, color, 'QuantityInput');

    return (
      <div
        className={classNames(className, {
          readOnly,
        })}
        onTouchEnd={this.handleTouchEnd}
      >
        <div
          className={classNames(DECREMENT_CLASS_NAME, {
            readOnly: readOnly || disableDecrement,
          })}
          onClick={this.decrementValue}
        >
          <Minus className="decrement-icon" />
        </div>
        <div
          className={classNames('QuantityInput__value text--alternate', {
            readOnly,
          })}
        >
          {value}
        </div>
        <div
          className={classNames(INCREMENT_CLASS_NAME, {
            readOnly: readOnly || disableIncrement,
          })}
          onClick={this.incrementValue}
        >
          <Plus className="increment-icon" />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/common/components/QuantityInput.js